// ── 로그 관리 — 스타일 상수 ────────────────────────────────────────────────────

/* 페이지 래퍼 */
export const pageStyle      = { padding: '0 0 40px' };
export const pageTitleStyle = { margin: '0 0 4px', fontSize: 20, fontWeight: 800, color: 'var(--text)' };
export const pageDescStyle  = { margin: '0 0 16px', fontSize: 13, color: 'var(--text-muted)' };

/* 필터 폼 */
export const filterFormStyle = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 12, padding: '14px 16px', marginBottom: 10,
};
export const filterRowStyle = {
  display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'flex-end',
};
export const filterLabelStyle = {
  display: 'flex', flexDirection: 'column', gap: 4,
  fontSize: 11, fontWeight: 700, color: 'var(--text-sub)',
};
export const filterInputStyle = {
  border: '1px solid var(--border)', borderRadius: 7,
  padding: '6px 9px', fontSize: 12, outline: 'none', height: 32,
};

/* 필터 액션 버튼 — 디자인 표준: 주요=검정 박스 / 보조=흰 외곽선 (designStandard 톤) */
export const btnPrimaryStyle = {
  height: 32, padding: '0 14px',
  background: 'var(--std-btn, #0f172a)', color: '#fff',
  border: '1px solid var(--std-btn, #0f172a)', borderRadius: 12, fontSize: 12, fontWeight: 700, cursor: 'pointer',
};
export const btnSecondaryStyle = {
  height: 32, padding: '0 12px',
  background: 'var(--bg-card)', color: 'var(--text-sub)',
  border: '1px solid var(--border)', borderRadius: 12, fontSize: 12, fontWeight: 700, cursor: 'pointer',
};

/* 활성 필터 칩 바 */
export const infoBarStyle = {
  display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap',
  padding: '6px 0 10px',
};
export const chipStyle = (bg, text) => ({
  display: 'inline-flex', alignItems: 'center',
  padding: '2px 10px', borderRadius: 999,
  background: bg, color: text,
  fontSize: 11, fontWeight: 700,
});

/* 데스크톱 테이블 — 디자인 표준: 라운드 8·1px 테두리·그림자 없음·검정 머리글 띠 */
export const tableWrapStyle = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 8, boxShadow: 'none', overflow: 'auto', WebkitOverflowScrolling: 'touch',
};
export const tblStyle = { width: '100%', borderCollapse: 'collapse', fontSize: 12 };
export const thStyle  = {
  padding: '10px 12px', background: 'var(--std-thead, #0f172a)',
  borderBottom: 'none',
  textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.92)',
  whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.04em',
};
export const trStyle = () => ({ background: 'var(--bg-card)' });
export const tdStyle  = {
  padding: '7px 10px', borderBottom: '1px solid var(--bg-subtle)',
  color: 'var(--text-sub)', verticalAlign: 'middle',
};

/* 배지 스타일 */
export const featureBadgeStyle = {
  display: 'inline-block', padding: '1px 7px',
  borderRadius: 6, fontSize: 10, fontWeight: 700,
};
export const methodBadgeStyle = {
  display: 'inline-block', padding: '2px 7px',
  borderRadius: 6, fontSize: 10, fontWeight: 800, fontFamily: 'monospace',
};
export const statusBadgeStyle = {
  display: 'inline-block', padding: '2px 7px',
  borderRadius: 6, fontSize: 11, fontWeight: 700,
};

/* 확장 영역 (request_body 표시) */
export const expandGridStyle  = { display: 'grid', gap: 4 };
export const expandLabelStyle = { fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', marginRight: 8 };

/* 동작 설명 텍스트 (기능 배지 아래) */
export const actionLabelStyle  = { fontSize: 11, fontWeight: 700, color: 'var(--text-sub)' };
export const actionDetailStyle = { fontSize: 11, color: 'var(--text-sub)' };

/* 한국어 필드 표 (펼치기 영역) */
export const bodyTableStyle = {
  borderCollapse: 'collapse', fontSize: 11,
  width: '100%', maxWidth: 600,
};
export const bodyKeyTdStyle = {
  padding: '3px 10px 3px 0', fontWeight: 700, color: 'var(--text-muted)',
  whiteSpace: 'nowrap', verticalAlign: 'top', width: 120,
};
export const bodyValTdStyle = {
  padding: '3px 0', color: 'var(--text-sub)', wordBreak: 'break-all',
};

/* JSON 코드 블록 */
export const jsonPreStyle = {
  margin: 0, padding: '8px 10px',
  background: 'var(--text-sub)', color: 'var(--border)',
  borderRadius: 8, fontSize: 11,
  overflowX: 'auto', maxHeight: 200,
  fontFamily: 'monospace', lineHeight: 1.5,
};

/* 빈 상태 / 로딩 플레이스홀더 */
export const placeholderStyle = { padding: 32, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 };

/* 모바일 카드 목록 */
export const mobileLogListStyle  = { display: 'flex', flexDirection: 'column', gap: 8 };
export const mobileLogCardStyle  = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 12, padding: '12px 14px',
  cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
};
export const mobileCardTopStyle  = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8,
};
export const mobileCardNameStyle = { fontSize: 13, fontWeight: 700, color: 'var(--text-sub)' };
export const mobileCardSubStyle  = { fontSize: 11, color: 'var(--text-muted)' };
export const mobileCardTimeStyle = { fontSize: 10, color: 'var(--text-muted)', whiteSpace: 'nowrap', flexShrink: 0 };
export const mobilePathStyle     = {
  fontFamily: 'monospace', fontSize: 11, color: 'var(--text-muted)',
  marginTop: 5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
};
export const mobileIpStyle = {
  fontSize: 10, fontFamily: 'monospace', color: 'var(--text-muted)',
  background: 'var(--bg-subtle)', borderRadius: 4, padding: '1px 5px',
};
export const mobileExpandStyle    = {
  marginTop: 10, paddingTop: 10,
  borderTop: '1px solid var(--bg-subtle)',
  display: 'grid', gap: 6,
};
export const mobileExpandRowStyle = { display: 'grid', gap: 2 };

/* 페이지네이션 */
export const paginationStyle = { display: 'flex', gap: 4, justifyContent: 'center', padding: '14px 0 0' };
export const pageBtnStyle = (active) => ({
  padding: '4px 9px',
  border: `1px solid ${active ? 'var(--std-btn, #0f172a)' : 'var(--border)'}`,
  borderRadius: 6, background: active ? 'var(--std-btn, #0f172a)' : 'var(--bg-card)',
  color: active ? '#fff' : 'var(--text-sub)',
  fontSize: 12, fontWeight: active ? 700 : 500, cursor: 'pointer',
});
